module.exports = __webpack_public_path__ + "aa95dbeb65e88d3335a3de7e353c502b.svg";